interface TapeProps {
  top?: number | string;
  left?: number | string;
  rotate?: number;
  width?: number;
  color?: string;
}

// Tape strips are intentionally DISABLED GLOBALLY across the app, regardless
// of theme. This component is a no-op so existing call sites keep compiling.
// Do not re-enable — see README.md ("UI conventions") and mem/constraint/no-tape.md.
export function Tape(_props: TapeProps) {
  return null;
}
